import { type JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const postServiceParts = async ({ serviceId, parts }: JsonDataItem) => {
  const { data } = await baseQuery('jobparts', {
    type: 'POST',
    body: {
      job_id: serviceId,
      parts,
    },
  });

  return data;
};
